import style from './summary-stat-card.module.scss';
import { FC } from 'react';
import classNames from 'classnames';
import { TooltipIcon } from 'components/tooltip-icon/tooltip-icon';
import { Filter, Information } from '@carbon/react/icons';

interface SummaryStatCardProps {
  title: string;
  value: string | undefined;
  valueColor?: 'default' | 'green' | 'red';
  tooltipText?: string;
  subtitle?: string;
  onFilterClick?: () => void;
  filterTooltip?: string;
}

const SummaryStatCard: FC<SummaryStatCardProps> = ({
  title,
  value,
  valueColor = 'default',
  tooltipText,
  subtitle,
  onFilterClick,
  filterTooltip,
}) => {
  const valueClass = classNames(style.value, {
    [style.valueGreen]: valueColor === 'green',
    [style.valueRed]: valueColor === 'red',
  });

  const titleLabel = tooltipText ? (
    <>
      <span className={style.titleWithTooltip}>{title}</span>
      <TooltipIcon definition={tooltipText} align="top-start" autoAlign>
        <Information size={16} />
      </TooltipIcon>
    </>
  ) : (
    <span>{title}</span>
  );

  return (
    <div className={style.summaryStatCardContainer}>
      <div className={style.summaryStatCardContent}>
        <div className={style.headerRow}>
          <div className={style.title}>{titleLabel}</div>
          {onFilterClick && (
            <TooltipIcon
              definition={filterTooltip || `Filter by ${title}`}
              onClick={onFilterClick}
              align="top-end"
              autoAlign
              className={style.filterButton}
            >
              <Filter />
            </TooltipIcon>
          )}
        </div>
        <div className={valueClass}>{value}</div>
        {subtitle && <div className={style.subtitle}>{subtitle}</div>}
      </div>
    </div>
  );
};

export { SummaryStatCard };
